module.exports = __webpack_public_path__ + "img/6.c1511e85.webp";